<template lang='pug'>
.v-bonus.basket-small(v-if="bonus")
	a.basket-small__widget(:href="bonus.link")
		.basket-small__image-wrap
			img.basket-small__image(v-if="bonus.image" :src="bonus.image" alt="" loading="lazy")
		.basket-small__title {{bonus.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			bonus: null
		};
	},

	methods: {
		dataSet(data) {
			this.bonus = data;
		}
	}
};
</script>